<script>
  /**
   * @typedef {Object} AcceptedPaymentCardTypes
   * @property {boolean} [dankort] - Indicates if Dankort is accepted.
   * @property {boolean} [visa_debit] - Indicates if Visa Debit is accepted.
   * @property {boolean} [visa_credit] - Indicates if Visa Credit is accepted.
   * @property {boolean} [mastercard_debit] - Indicates if MasterCard Debit is accepted.
   * @property {boolean} [mastercard_credit] - Indicates if MasterCard Credit is accepted.
   */

  /**
   * @typedef {Object} PaymentCardType
   * @property {string} image_url - The URL for the card's image.
   */

  /**
   * @type {AcceptedPaymentCardTypes}
   * Object from the API representing which payment card types are accepted by the shop.
   */
  export let acceptedPaymentCardTypes;

  /**
   * @type {Array<Object<string, PaymentCardType>>}
   * Array containing an object where keys are card types (e.g., 'visa', 'dankort') and values contain metadata, such as the image URL.
   */
  export let paymentCardTypes;

  /**
   * Determines if the card type should be enabled based on accepted payment types from the API.
   *
   * @param {string} card - The type of card to check (e.g., 'visa', 'dankort').
   * @returns {boolean} - True if the card is enabled and accepted, false otherwise.
   */
  function cardEnabled(card) {
    if (card === 'dankort' && acceptedPaymentCardTypes.dankort) {
      return true;
    }
    if (card === 'visa' && (acceptedPaymentCardTypes.visa_debit || acceptedPaymentCardTypes.visa_credit)) {
      return true;
    }
    if (card === 'mastercard' && (acceptedPaymentCardTypes.mastercard_debit || acceptedPaymentCardTypes.mastercard_credit)) {
      return true;
    }
    return false;
  }
</script>

<!-- Payment Cards Section -->
<div class="cards">
  Optjen med:
  {#each Object.entries(paymentCardTypes[0]) as [cardType, cardData]}
    {#if cardEnabled(cardType)}
      <span class="card">
        <img src={cardData.image_url} alt={cardType} />
      </span>
    {/if}
  {/each}
</div>
